import {useDispatch, useSelector} from "react-redux";
import GlobalConst from "../../constants/GlobalConst";
import {useEffect, useMemo, useRef, useState} from "react";
import {selectLocale} from "../../stores/account/account.selectors";
import {
    selectSelectedParlayId,
    selectUserParlayByType,
    selectContestIdsNotOnLobby,
    makeCanAddPlayerToParlayChecker, selectContestsByIds, selectPrizeAssetById
} from "../../stores/pickX/pickX.selectors";
import {createYourOwnParlay} from "../../stores/pickX/pickX.thunks";
import {setSelectedParlayId} from "../../stores/pickX/pickX.slice";
import pickXApi,{useGetContestsLobbyDataQuery} from "../../stores/pickX/pickX.api";
import {ParlayType} from "../../constants/PickXEnums";
import moment from "moment/moment";
import {ModalType} from "../../components/AppModal/ModalTypes";
import GenericWelcomePopUp from "../PopUps/WelcomePopUps/GenericWelcomePopUp";
import LobbyWelcomePopUp from "../PopUps/WelcomePopUps/LobbyWelcomePopUp";
import useAppModalService from "../../hooks/useAppModalService";

const ScheduleGameStatus = ["scheduled", "notstarted", "not_started", "delayed", "startdelayed"];

const useCreateYourOwnParlayViewModel = ()=>{
    const dispatch = useDispatch();
    const modalServices = useAppModalService();
    const userParlayId = "newCreateYourOwn";
    const isInitialized = useRef(false);
    const locale = useSelector(selectLocale);
    const selectedParlayId = useSelector(selectSelectedParlayId);
    const createOwnParlay = useSelector(state=>selectUserParlayByType(state, ParlayType.CreateYourOwn));
    const notFromLobbyContestIds = useSelector(selectContestIdsNotOnLobby);
    const canAdd = useSelector(makeCanAddPlayerToParlayChecker(userParlayId));

    const [preSelectedParlayBannersExists, setPreSelectedParlayBannersExists] = useState(false);
    //filter
    const [filters, setFilters] = useState({
        sportId: null,
        gameId: null,
        seasonId: null,
        searchTerm: '',
        position: null,
        market: null
    });

    const handleFilterChange = (key, value) => {
        setFilters(prevFilters => {
            let filter = ({
                ...prevFilters,
                [key]: value,
            });

            if (key === 'gameId') {
                const game = createYourOwnViewData.games.find(g => g.GameId === value);
                filter.sportId = game?.SportId;
            }
            if( key === 'market' ){
                filter.position = null;
            }
            if( key === 'position' ){
                filter.market = null;
            }

            const changeLeague = key === 'sportId' && value !== prevFilters.sportId;
            if (changeLeague) {
                filter.gameId = null;
                filter.position = null;
                filter.searchTerm = '';
                filter.seasonId = null;
                filter.market = null;
            }
            return filter;
        });
    };

    const handleResetFilter = () => {
        setFilters({
            sportId: null,
            gameId: null,
            seasonId: null,
            searchTerm: '',
            position: null,
            market: null
        });
    }

    useEffect(() => {
        if (!isInitialized.current) {
            if (!createOwnParlay)
                dispatch(createYourOwnParlay({userParlayId}));
            else if (createOwnParlay && (selectedParlayId == null || createOwnParlay.Id !== selectedParlayId))
                dispatch(setSelectedParlayId(createOwnParlay.Id));
            isInitialized.current = true;
        }


        /*modalServices.openModal('lobbyWelcomePopUp', ModalType.CUSTOM, {
            modalComponent: LobbyWelcomePopUp,
            onOk: () => {
                //navigate('/lobby');
            }
        })*/

    }, []);

    const { data: lobbyCreateYourOwnData, isLoading } = useGetContestsLobbyDataQuery();

    const contestIds = lobbyCreateYourOwnData?.Contests.map(c => c.Id) ?? [];
    const contests = useSelector( state=>selectContestsByIds(state, contestIds) )
    const contestsLineValueHash = contests.map(c=>c.LineValue).join();

    const createYourOwnViewData = useMemo(()=>{

        if(!lobbyCreateYourOwnData)
            return {
                contests: [],
                games: [],
                playersStats: [],
                players: [],
                contestsMap: new Map(),
                playersMap: new Map(),
                playersStatsMap: new Map(),
                gamesMap: new Map(),
                lastUpdate: new Date().getTime(),
            }

        //note: removed TCP contests:
        const contestsMap = new Map(contests.filter(c=>c.StatsKey !== "TCP").map(c=>[c.Id, c]));
        const playersMap = new Map(lobbyCreateYourOwnData.Players.map(p => [p.PlayerId, p]));
        const playersStatsMap = new Map(lobbyCreateYourOwnData.PlayersStats.map(ps => [ps.PlayerId, ps]));
        const gamesMap = new Map(lobbyCreateYourOwnData.Games.map(g =>  [g.GameId, g] ));

        const statsKeysBySportMap = contests.map(c=>[ c.SportId, c.StatsKey ]).reduce((acc, [sportId, statsKey]) => {
            if (!acc[sportId]) acc[sportId] = [];
            if (!acc[sportId].includes(statsKey))
                acc[sportId].push(statsKey);
            return acc;
        }, {});

        return {
            //arrays
            contests: contests.map(c => ({
                ...c,
                player: {
                    ...playersMap.get(c.PlayerId),
                    TeamId: playersMap.get(c.PlayerId).TeamId || playersStatsMap.get(c.PlayerId)?.TeamId,
                },
                playerStats: playersStatsMap.get(c.PlayerId),
                game: gamesMap.get(c.GameId),
            })),
            games: lobbyCreateYourOwnData.Games.map(g => ({
                ...g,
                sportId: gamesMap.get(g.GameId).sportId,
            })),
            playersStats: lobbyCreateYourOwnData.PlayersStats,
            players: lobbyCreateYourOwnData.Players.map(p => ({
                ...p,
                TeamId: p.TeamId || playersStatsMap.get(p.PlayerId)?.TeamId,
                stats: playersStatsMap.get(p.PlayerId),
            })),
            //maps
            contestsMap,
            playersMap,
            playersStatsMap,
            gamesMap,
            statsKeysBySportMap,
            //timestamps
            lastUpdate: new Date().getTime(),
        };
    },[contestsLineValueHash, lobbyCreateYourOwnData, contests]);

    const [preFilteredContests, filteredContests] = useMemo(() =>
            filterContests(filters, createYourOwnViewData, locale, notFromLobbyContestIds),
        [contestsLineValueHash, filters, createYourOwnViewData?.lastUpdate, locale, notFromLobbyContestIds]
    );



    const filteredGames = useMemo(() => {
        const scheduledGamesFilter = (game)=> ScheduleGameStatus.includes(game.Status);
        if (!filters.sportId) return createYourOwnViewData?.games.filter(scheduledGamesFilter) ?? [];
        return createYourOwnViewData.games.filter(g => g.SportId === filters.sportId)
                                          .filter(scheduledGamesFilter);
    }, [filters.sportId, createYourOwnViewData?.games]);

    const filteredStatsKeysBySport = useMemo(() => {
        const map = createYourOwnViewData?.statsKeysBySportMap || {};
        const bySport = id => map[id] || [];

        const positionSet = filters.position
            ? new Set(
                (filteredContests || [])
                    .filter(c => c?.player?.Position === filters.position)
                    .map(c => c.StatsKey)
            )
            : null;

        const pickForSport = sportId => {
            const base = bySport(sportId);
            return positionSet ? base.filter(k => positionSet.has(k)) : base;
        };

        if (filters.sportId) {
            return { [filters.sportId]: pickForSport(filters.sportId) };
        }

        return Object.keys(map).reduce((acc, sportId) => {
            acc[sportId] = pickForSport(sportId);
            return acc;
        }, {});
    }, [
        filters.sportId,
        filters.position,
        filteredContests,
        createYourOwnViewData?.statsKeysBySportMap
    ]);

    const showAll = lobbyCreateYourOwnData?.Contests.length === filteredContests.length;

    return {
        viewType : "LobbyCreateYourOwn",
        preFilteredContests,
        filteredContests,
        filteredGames,
        filteredStatsKeysBySport,
        viewData: createYourOwnViewData,
        selectedParlay : createOwnParlay,
        isLoading,

        canAdd,

        preSelectedParlayBannersExists,
        setPreSelectedParlayBannersExists,
        //filter
        showAll,
        filters,
        handleFilterChange,
        handleResetFilter
    }
};

export const filterContests = (filters, createYourOwnViewData, locale, notFromLobbyContestIds) => {
    const preFiltered = createYourOwnViewData.contests.filter(c => (
        c.IsOnLobby && !notFromLobbyContestIds.includes(c.Id) &&
        (!filters.sportId || c.SportId === filters.sportId) &&
        (!filters.seasonId || c.SeasonId === filters.seasonId) &&
        (!filters.gameId || c.GameId === filters.gameId) &&
        (!filters.market || c.StatsKey === filters.market) &&
        (!filters.searchTerm || (
            c.Name[locale].toLowerCase().includes(filters.searchTerm.toLowerCase()) ||
            c.player.FirstName.toLowerCase().includes(filters.searchTerm.toLowerCase()) ||
            c.player.LastName.toLowerCase().includes(filters.searchTerm.toLowerCase())
        ))
    ));

    const groupedBySport = preFiltered.reduce((acc, c) => {
        (acc[c.SportId] = acc[c.SportId] || []).push(c);
        return acc;
    }, {});
    const percentileData = Object.values(groupedBySport).flatMap(group => {
        group.sort((a, b) => b.playerStats?.FPPG - a.playerStats?.FPPG);

        return group.map((contest, index) => ({
            ...contest,
            FPPGPercentile: 1 - index / group.length,
        }));
    });

    const sortedByFPPG = percentileData.sort((a, b) => b.FPPGPercentile - a.FPPGPercentile);
    let filtered = sortedByFPPG;

    if (filters.position)
        filtered = sortedByFPPG.filter(c => c.player?.Position === filters.position);

    const now = moment();
    filtered = filtered.filter(c => !c.playerStats || moment(c.playerStats?.DateTime).isAfter(now))

    if (GlobalConst.FEATURES.DOTMX) {
        const MX_LEAGUE_ORDER = ["130979", "130281", "127179", "131609"];
        filtered = filtered.sort((a, b) => {
            // 1. Sport: soccer first
            const sportDiff = (a.SportId === 3 ? 0 : 1) - (b.SportId === 3 ? 0 : 1);
            if (sportDiff !== 0) return sportDiff;
            // 2. League: MX order within soccer
            if (a.SportId === 3) {
                const ai = MX_LEAGUE_ORDER.indexOf(a.SeasonId);
                const bi = MX_LEAGUE_ORDER.indexOf(b.SeasonId);
                const leagueDiff = (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
                if (leagueDiff !== 0) return leagueDiff;
            }
            // 3. FPPG: higher percentile first
            return b.FPPGPercentile - a.FPPGPercentile;
        });
    }

    return [preFiltered, filtered];
}


export default useCreateYourOwnParlayViewModel;
